export const UserRole = {
    DIRECTOR: 'director',
    PROFESSOR: 'professor',
    STUDENT: 'student',
    /** Technical-support staff: handles incident tickets from students/professors.
     *  Intentionally separate from director so technical issues don't reach them. */
    SUPPORT: 'support',
};
/** Lifecycle of a technical-support incident ticket. */
export const SupportTicketStatus = {
    OPEN: 'open',
    CLOSED: 'closed',
};
export const OppositionType = {
    POLICIA_LOCAL: 'policia_local',
    POLICIA_NACIONAL: 'policia_nacional',
    BOMBEROS: 'bomberos',
};
export const StudentStatus = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    TEMPORARY_LEAVE: 'temporary_leave',
    APPROVED: 'approved',
};
export const PaymentStatus = {
    PAID: 'paid',
    PENDING: 'pending',
    OVERDUE: 'overdue',
    EXEMPT: 'exempt',
};
/** What a payment is for: the recurring monthly fee or a one-off enrollment (matrícula). */
export const PaymentConcept = {
    MONTHLY: 'monthly',
    ENROLLMENT: 'enrollment',
};
/** Standard enrollment (matrícula) fee, in cents. Prefilled when generating a
 *  matrícula charge; the director can still edit it for special cases. */
export const DEFAULT_ENROLLMENT_FEE_CENTS = 5000;
/** Reduced monthly fee, in cents (65 €). The director can switch a pending
 *  monthly payment between the student's full fee and this reduced amount. */
export const REDUCED_MONTHLY_FEE_CENTS = 6500;
export const AttendanceStatus = {
    PRESENT: 'present',
    ABSENT: 'absent',
    LATE: 'late',
    JUSTIFIED: 'justified',
};
export const RequestType = {
    SHIFT_CHANGE: 'shift_change',
    SINGLE_CLASS_CHANGE: 'single_class_change',
    CLASS_MATERIAL_ACCESS: 'class_material_access',
    TEMPORARY_LEAVE: 'temporary_leave',
    DATA_CORRECTION: 'data_correction',
    DATA_EXPORT: 'data_export',
    DATA_DELETION: 'data_deletion',
    RECORDED_CLASS: 'recorded_class',
    ONLINE_CLASS_ACCESS: 'online_class_access',
    OTHER: 'other',
};
export const RequestStatus = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
export const ProspectStatus = {
    NEW: 'new',
    CONTACTED: 'contacted',
    ENROLLED: 'enrolled',
    DISCARDED: 'discarded',
};
export const NotificationType = {
    PAYMENT_REMINDER: 'payment_reminder',
    SCHEDULE_PUBLISHED: 'schedule_published',
    MATERIAL_ASSIGNED: 'material_assigned',
    MATERIAL_ACCESS_GRANTED: 'material_access_granted',
    REQUEST_RESOLVED: 'request_resolved',
    ANNOUNCEMENT_UPDATE: 'announcement_update',
    ATTENDANCE_REMINDER: 'attendance_reminder',
    BLOG_POST_PUBLISHED: 'blog_post_published',
    SYSTEM: 'system',
    /** Personal message sent by a director/professor to a specific student. */
    CUSTOM_MESSAGE: 'custom_message',
    /** New message in a technical-support incident thread (to support or reporter). */
    SUPPORT_MESSAGE: 'support_message',
};
export const AnnouncementStatus = {
    UPCOMING: 'upcoming',
    OPEN: 'open',
    CLOSED: 'closed',
    RESULTS: 'results',
};
export const BlogPostStatus = {
    DRAFT: 'draft',
    PUBLISHED: 'published',
};
//# sourceMappingURL=index.js.map